/**
 * Switches for the Idibu integration demo mode.
 *
 * `IDIBU_DEMO_MODE` — when true, the SPA uses an in-memory mock
 * implementation of `idibuApi` that returns realistic-looking but
 * synthetic data. The real backend is never called.
 *
 * `IDIBU_READ_ONLY` — when true, every mutating control on /settings/job-board
 * (Disconnect, Connect, Provision, Subscribe, Unsubscribe) is disabled, so
 * the demo state can't be accidentally broken. Reads (Test connection,
 * filtering, browsing) remain enabled.
 *
 * To revert: flip the flag(s) to `false`, or delete the demo/ folder
 * and remove the conditional export from ../services/idibu.api.ts.
 */
export const IDIBU_DEMO_MODE = true;
export const IDIBU_READ_ONLY = true;
